import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Motive from '../Motive';
import { ISSUES } from '../../../../constants/issues';
import { useIssueContainerStyles } from './styles';
import { setIdType } from '../../../../redux/slices/BreadcrumbsSlice';

const IssueContainer = ({ ...props }) => {
  const { mobile } = props;
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);

  const { idType } = useSelector((state) => state.breadcrumbsSlice);

  useEffect(() => {
    if (idType !== '') setExpanded(idType);
  }, []);

  const classes = useIssueContainerStyles({ mobile });

  const handleChange = (panel) => (event, isExpanded) => {
    dispatch(setIdType(panel));
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box width="100%" className={classes.container}>
      {ISSUES.map((issue, index) => (
        <React.Fragment key={index}>
          <Accordion
            expanded={expanded === index}
            onChange={handleChange(index)}
            elevation={0}
            width="100%"
            disabled={issue.disabled}
            className={classes.accordion}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box display="flex" alignItems="center">
                {issue.isNew ? (
                  <span className={classes.point}>¡Nuevo!</span>
                ) : (
                  ''
                )}
                <img className={classes.icon} src={issue.icon} alt="icon" />
                <Box display="flex" flexDirection="column">
                  <Typography className={classes.title}>
                    {issue.title}{' '}
                  </Typography>
                  <Typography className={classes.subtitle}>
                    {issue.subtitle}{' '}
                  </Typography>
                </Box>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Motive
                mobile={mobile}
                motives={issue.motives}
                issueId={issue.id}
              />
            </AccordionDetails>
          </Accordion>
        </React.Fragment>
      ))}
    </Box>
  );
};

IssueContainer.propTypes = {
  mobile: PropTypes.bool,
};

export default IssueContainer;
